import { makeActionCreator } from '../App_Code/Utils';
import { ActVote } from '../App_Data/ActionTypes';
import { obtenirVotantAvecVotes } from '../App_Code/API';

export function VoteObtenirVotes() {
    return (dispatch) => {
        // dispatch({ type: ActMes.MES_CHARGEMENT });
        obtenirVotantAvecVotes().then((votes) => {
            dispatch({ type: ActVote.VOTES_RECUP, data: votes });
        });
    };
}

export function VoteMajNumReunion(Num) {
    return (dispatch) => {
        dispatch({ type: ActVote.VOTES_CHOIX, data: Num });
    };
}




// WEBPACK FOOTER //
// ./src/Actions/VoteActions.js